module.exports = __webpack_public_path__ + "static/404-illustration-42d4e1910af3cb328c908ee33b02b825.svg";